module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-13.5eee8e74.jpg";